import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AutosizeModule } from 'ngx-autosize';

import { LessonPage } from './lesson.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { AddSongsSlideoutComponent } from './add-songs-slideout/add-songs-slideout.component';
import { AddPemSlideoutComponent } from './add-pem-slideout/add-pem-slideout.component';
import { ShowHideColumnsComponent } from './show-hide-columns/show-hide-columns.component';
import { PemDetailComponent } from './pem-detail/pem-detail.component';
import { LessonSongComponent } from './lesson-song/lesson-song.component';
import { LessonSongCssService } from './lesson-song-css.service';
import { ResizeableColumnComponent } from './resizeable-column/resizeable-column.component';

import { DragulaModule, DragulaService } from 'ng2-dragula'


const routes: Routes = [
  {
    path: '',
    component: LessonPage
  }
];

@NgModule({
  declarations: [
    LessonPage,
    AddSongsSlideoutComponent,
    AddPemSlideoutComponent,
    PemDetailComponent,
    ShowHideColumnsComponent,
    LessonSongComponent,
    ResizeableColumnComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentsModule,
    DragDropModule,
    AutosizeModule,
    DragulaModule
  ],
  exports: [
    AddSongsSlideoutComponent,
    AddPemSlideoutComponent,
    PemDetailComponent,
    ShowHideColumnsComponent
  ],
  providers: [
    LessonSongCssService,
    DragulaService
  ]
})
export class LessonPageModule {}
